<div class="action-chooser-container" appTrapFocus (click)="choose(false)" #modal *ngIf="actions" [class.hide]="!show" [class.show]="show" role="dialog" aria-modal="true" aria-label="post options">
  <div class="action-list">
    <div class="action-title" [innerHTML]="title | safe: 'html'"></div>
    <button class="btn btn-transparent btn-block action-item" *ngFor="let action of actions" (click)="choose(action, $event)" [innerHTML]="action | safe: 'html'"></button>
    <button class="btn btn-transparent btn-block action-item cancel" (click)="choose(false, $event)">{{ "sphere.cancel" | translate }}</button>
  </div>
</div>
